import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=abeb3b96"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=abeb3b96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports